import { Injectable } from '@angular/core';

import { environment } from '@env/environment';
import { AppService } from '@app/services/app.service';

@Injectable({
  providedIn: 'root'
})
export class EnterpriseService {
  constructor(private appService: AppService) {}

  /**
   * This function avoids users from getting out of the documents page after they open a link to it from an email or somewhere else.
   */
  hideDocumentBackButton(): boolean {
    return (
      this.hideForEnterprise() &&
      (!this.appService.previousUrl || ['/', '/documentos', '/documentos/todos', '/401'].includes(this.appService.previousUrl) || this.appService.previousUrl.startsWith('/assinar/'))
    );
  }

  hideForEnterprise(): boolean {
    return ['sign.pipefy.com'].includes(location.hostname);
  }

  /**
   * This function activates A3 Cloud Signature only for self and Pipefy domains.
   */
  ableForExclusiveDomains(allowedDomains: string[] = ['sign.pipefy.com']) {
    if (this.appService.isAutentiqueDomain() || environment.electron) return true;
    return allowedDomains.includes(location.hostname);
  }
}
